import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';

import store from '../store/index';

import { getStorageValue, setStorageValue } from './indexdb-service';

import { getToken } from './user';

const apiClient = axios.create({ baseURL: process.env.REACT_APP_BASE_URL, withCredentials: false });

apiClient.interceptors.request.use(async (requestConfig) => {
    let deviceIdentifier = await getStorageValue('deviceIdentifier');

    if (!deviceIdentifier) {
        deviceIdentifier = uuidv4();

        await setStorageValue('deviceIdentifier', deviceIdentifier);
    }

    requestConfig.headers['x-device-identifier'] = deviceIdentifier;
    requestConfig.headers['x-user-local-time'] = moment().format('YYYY-MM-DD HH:mm:ss');

    return requestConfig;
});

apiClient.interceptors.response.use((response) => {
    return response;
}, (error) => {
    const token = getToken();

    if (token && error?.response?.status === 401) {
        store.dispatch({ type: "SET_LOGOUT" });
    }

    return Promise.reject(error);
});

export default apiClient;
